
    <h1>Política de Privacidad</h1>

    <p>Última actualización: 12 de diciemnbre de 2023</p>

    <p>Esta Política de Privacidad describe cómo Safaera ("nosotros", "nos" o "nuestro") recopila, utiliza y comparte su información personal cuando utiliza nuestra aplicación móvil Safaera (la "Aplicación").</p>

    <p>Al utilizar la Aplicación, acepta la recopilación y el uso de su información de acuerdo con esta Política de Privacidad. Si no está de acuerdo con los términos de esta Política de Privacidad, por favor, no utilice la Aplicación.</p>

    <h2>1. Datos Utilizados para Rastrearte</h2>

    <p>Los siguientes datos pueden ser utilizados para rastrearte en otras aplicaciones y sitios web propiedad de otras empresas:</p>

    <ul>
        <li>Información de Contacto:
            <ul>
                <li>Nombre, email, fecha de nacimiento, género.</li>
            </ul>
        </li>
    </ul>

    <h2>2. Datos Vinculados a Ti</h2>

    <p>Los siguientes datos pueden ser recopilados y vinculados a tu identidad:</p>

    <ul>
        <li>Información de Contacto:
            <ul>
                <li>email.</li>
            </ul>
        </li>
        <li>Contenido del Usuario:
            <ul>
                <li>imagen de perfil, nombre, contenido gustado, visto, guardado, compartido.</li>
            </ul>
        </li>
        <li>Identificadores:
            <ul>
                <li>Nombre, email.</li>
            </ul>
        </li>
        <li>Datos de Uso:
            <ul>
                <li>Contenido visto, gustado, guardado, compartido, cliqueado.</li>
            </ul>
        </li>
    </ul>

    <h2>3. Dirección de Correo Electrónico</h2>

    <p><strong>Utilizado para Publicidad o Marketing del Desarrollador</strong></p>

    <ul>
        <li>Vinculado a la identidad del usuario:
            <ul>
                <li>Email.</li>
            </ul>
        </li>
        <li>Utilizado con fines de seguimiento:
            <ul>
                <li>Mejorar experiencia de usuario dentro de la aplicación</li>
            </ul>
        </li>
    </ul>

    <h2>4. Seguridad</h2>

    <p>Nos comprometemos a garantizar que su información esté segura. Hemos implementado medidas físicas, técnicas y administrativas razonables para salvaguardar y asegurar la información que recopilamos a través de la Aplicación.</p>

    <h2>5. Cambios en Esta Política de Privacidad</h2>

    <p>Podemos actualizar nuestra Política de Privacidad de vez en cuando. Por lo tanto, se le recomienda revisar esta página periódicamente para conocer cualquier cambio. Le informaremos de cualquier cambio publicando la nueva Política de Privacidad en esta página.</p>

    <h2>6. Contáctenos</h2>

    <p>Si tiene alguna pregunta o sugerencia sobre nuestra Política de Privacidad, contáctenos en safaeraapp@gmail.com.</p>
